
<template>
    <div>
        <el-dialog title="反馈图片" :visible.sync="dialogReport">
           <img :src="datalist" style="width: 100%;">
        </el-dialog>
    </div>
</template>
<script>
    import {getImgLink} from '@/config/env'
    export default {
        data() {
            return {
                dialogReport : false,
                datalist : [],
                option:{
                    height:300,
                    autoplay : false,
                    data:[]
                }
            }
        },
        created() {},

        methods: {
            //设置展示
            imgstate(data){
                this.datalist = [];
                this.dialogReport = true;
                this.datalist = data;
            },


        }
    }
</script>
